const xeVisuals = [
  {
    src: "/images/xe/Advisor%20change%20date.png",
    alt: "Advisor screen: change date",
    caption: "Advisor change date",
  },
  {
    src: "/images/xe/Advisor%20enter%20paid%20amount.png",
    alt: "Advisor screen: enter paid amount",
    caption: "Advisor paid amount",
  },
  {
    src: "/images/xe/Advisor%20enter%20received%20amount.png",
    alt: "Advisor screen: enter received amount",
    caption: "Advisor received amount",
  },
  {
    src: "/images/xe/Advisor%20result%202.png",
    alt: "Advisor result screen variant",
    caption: "Advisor result 2",
  },
  {
    src: "/images/xe/Advisor%20result.png",
    alt: "Advisor result screen",
    caption: "Advisor result",
  },
  {
    src: "/images/xe/Advisor.png",
    alt: "Advisor main screen",
    caption: "Advisor",
  },

  {
    src: "/images/xe/Chart%20-%20change%20currency.png",
    alt: "Chart: change currency",
    caption: "Chart change currency",
  },
  {
    src: "/images/xe/Chart%20-%20rollover.png",
    alt: "Chart: rollover state",
    caption: "Chart rollover",
  },
  {
    src: "/images/xe/Chart%20-%20rollover2.png",
    alt: "Chart: rollover state 2",
    caption: "Chart rollover 2",
  },
  {
    src: "/images/xe/Chart%20-%20rollover3.png",
    alt: "Chart: rollover state 3",
    caption: "Chart rollover 3",
  },
  {
    src: "/images/xe/Chart%20Inverse.png",
    alt: "Chart inverse view",
    caption: "Chart inverse",
  },
  { src: "/images/xe/Chart.png", alt: "Chart main view", caption: "Chart" },

  {
    src: "/images/xe/Converter%20-%20change%20amount%201.png",
    alt: "Converter: change amount step 1",
    caption: "Converter amount 1",
  },
  {
    src: "/images/xe/Converter%20-%20change%20amount%202.png",
    alt: "Converter: change amount step 2",
    caption: "Converter amount 2",
  },
  {
    src: "/images/xe/Converter%20-%20change%20amount%203.png",
    alt: "Converter: change amount step 3",
    caption: "Converter amount 3",
  },
  {
    src: "/images/xe/Converter%20-%20change%20amount%204.png",
    alt: "Converter: change amount step 4",
    caption: "Converter amount 4",
  },

  {
    src: "/images/xe/Converter%20change%20base%20currency%20eur.png",
    alt: "Converter: change base currency to EUR",
    caption: "Base currency EUR",
  },
  {
    src: "/images/xe/Converter%20change%20base%20currency%20gbp.png",
    alt: "Converter: change base currency to GBP",
    caption: "Base currency GBP",
  },
  {
    src: "/images/xe/Converter%20change%20base%20currency%20usd.png",
    alt: "Converter: change base currency to USD",
    caption: "Base currency USD",
  },

  {
    src: "/images/xe/Converter%20edit%20currency%20Add%20currency%202.png",
    alt: "Converter: add currency step 2",
    caption: "Add currency 2",
  },
  {
    src: "/images/xe/Converter%20edit%20currency%20Add%20currency%203.png",
    alt: "Converter: add currency step 3",
    caption: "Add currency 3",
  },
  {
    src: "/images/xe/Converter%20edit%20currency%20Add%20currency%20done.png",
    alt: "Converter: add currency completed",
    caption: "Add currency done",
  },
  {
    src: "/images/xe/Converter%20edit%20currency%20Add%20currency.png",
    alt: "Converter: add currency",
    caption: "Add currency",
  },
  {
    src: "/images/xe/Converter%20edit%20currency.png",
    alt: "Converter: edit currency",
    caption: "Edit currency",
  },
];

// Intentionally exclude apple-touch-startup-image.png from the carousel/grid.
// If you want it later for favicons/splash, handle separately.

export default xeVisuals;
